import React, {useState} from 'react';
import { Tooltip as ReactTooltip } from 'reactstrap';

const TooltipItem = (props) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);
    return  (
        <span>
            { props.label }
            <i className="far fa-circle-question ml-1" id={props.id}></i>
            <ReactTooltip placement="top" boundariesElement=".table-responsive" isOpen={tooltipOpen} target={props.id} toggle={toggle}>
                { props.description }
            </ReactTooltip>    
        </span>
    )
}

export default TooltipItem;